import React from 'react'
import Auth from 'label-insight-auth'
import config from 'config'
import net1 from './assets/net-1.svg'
import net2 from './assets/net-2.svg'
import net3 from './assets/net-3.svg'
import styles from './Menu.scss'

class Menu extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      show: false
    }
    this.keypress = this.keypress.bind(this)
    this.toggleShow = this.toggleShow.bind(this)
  }

  componentDidMount() {
    document.body.addEventListener('keyup', this.keypress)
  }

  componentWillUnmount() {
    document.body.removeEventListener('keyup', this.keypress)
  }

  keypress(e) {
    if (e.keyCode !== 27) { return }
    this.toggleShow()
  }

  toggleShow() {
    this.setState({ show: !this.state.show })
  }

  render() {
    const { show } = this.state
    return (
      <div>
        <nav className={`${styles.navbar} clearfix`}>
          <div
            className={`${styles.hamburger} ${show ? styles.open : ''}`}
            onClick={this.toggleShow}
          >
            <span />
            <span />
            <span />
            <span />
          </div>
        </nav>
        <div style={{ display: show ? 'block' : 'none' }} className={styles.menu}>
          <div className={styles.overlay}>
            <div
              className={`${styles.net} ${styles.net1}`}
              style={{ backgroundImage: `url(${net1})` }}
            />
            <div
              className={`${styles.net} ${styles.net2}`}
              style={{ backgroundImage: `url(${net3})` }}
            />
            <div
              className={`${styles.net} ${styles.net3}`}
              style={{ backgroundImage: `url(${net2})` }}
            />
          </div>
          <div className={styles.menuinner}>
            <section className={styles.workflow}>
              <h2>
                Global Decisions
              </h2>
              <ul>
                <li>
                  <a href='/off-package-loader' className='white'>
                    Off Package Loader
                  </a>
                </li>
                <li>
                  <a href='/default-edit' className='white'>
                    Default Edits
                  </a>
                </li>
                <li>
                  <a href='/additional-links' className='white'>
                    Additional URLs
                  </a>
                </li>
                <li>
                  <a href='/submit-ingredient-additions' className='white'>
                    Bulk Add Ingredients
                  </a>
                </li>
                <li>
                  <a href='/bulk-add-claims' className='white'>
                    Bulk Add Claims
                  </a>
                </li>
                <li>
                  <a href='/label-sync-config' className='white'>
                    LabelSync Configurations
                  </a>
                </li>
              </ul>
            </section>
            <section className={styles.index}>
              <h2>
                Workflow
              </h2>
              <ul>
                <li>
                  <a href='/button/casper-init' className='white'>
                    Initialize
                  </a>
                </li>
                <li>
                  <a href='/button/productStatus' className='white'>
                    Update Product Status
                  </a>
                </li>
                <li>
                  <a href='/bulk-ingredient-toggle' className='white'>
                    Hide/Show Ingredient Descriptions
                  </a>
                </li>
              </ul>
            </section>
            <section className={styles.workflow}>
              <h2>
                Tools
              </h2>
              <ul>
                <li>
                  <a href='/rebuild-elasticsearch-data' className='white'>
                    Rebuild Elasticsearch Data
                  </a>
                </li>
                <li>
                  <a href='/button/apply-defaults' className='white'>
                    Apply Defaults to Products
                  </a>
                </li>
              </ul>
            </section>
            <section className={styles.account}>
              <ul>
                <li>
                  {new Auth(config.auth.env).getToken() ?
                    <a href='/logout' className='white'>
                      Log out
                    </a>
                  :
                    <a href='/login' className='white'>
                      Log in
                    </a>
                  }
                </li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    )
  }
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js